
import { Vue, Component, Prop } from 'vue-property-decorator';


@Component({

})
export default class UiButton extends Vue {
	@Prop({ type: String, default: '#717986' }) readonly fill: string;


}
